import type { Client } from "../services/clientService";

export type ClientListSignal =
  | "onlineBookingBlocked"
  | "incompleteProfile"
  | "activeSessions"
  | "club"
  | "activeProtocol"
  | "loyalty"
  | "healthRecords";

const MAX_VISIBLE_SIGNALS = 3;

export function isClientProfileIncomplete(
  client: Pick<Client, "birth_date" | "instagram_handle" | "acquisition_source">
): boolean {
  const instagram = (client.instagram_handle ?? "").trim();
  const acquisition = (client.acquisition_source ?? "").trim();

  return !client.birth_date || instagram === "" || acquisition === "";
}

/** Ops-first priority for list badges (alerts → money → membership → clinical). */
export function getClientListSignals(client: Client): ClientListSignal[] {
  const signals: ClientListSignal[] = [];

  if (client.allow_online_booking === false) {
    signals.push("onlineBookingBlocked");
  }
  if (isClientProfileIncomplete(client)) {
    signals.push("incompleteProfile");
  }
  if ((client.active_credits_count ?? 0) > 0) {
    signals.push("activeSessions");
  }
  if (client.has_active_club) {
    signals.push("club");
  }
  if ((client.active_protocols_count ?? 0) > 0) {
    signals.push("activeProtocol");
  }
  if (client.has_loyalty_card) {
    signals.push("loyalty");
  }
  if ((client.health_records_count ?? 0) > 0) {
    signals.push("healthRecords");
  }

  return signals;
}

export function splitClientListSignals(
  signals: ClientListSignal[],
  maxVisible = MAX_VISIBLE_SIGNALS
): { visible: ClientListSignal[]; overflow: number } {
  return {
    visible: signals.slice(0, maxVisible),
    overflow: Math.max(0, signals.length - maxVisible),
  };
}
